/**
 * 接口域名的管理
 */
const base = () => {
  // console.log(process.env,5666666666666);
  switch (process.env.NODE_ENV) {
    case "test":
      return "https://test.b-chem.com";
    case "production":
      return "https://www.b-chem.com";
    default:
      return "/api";
  }
};
const beixiu = () => {
  // console.log(process.env,5666666666666);
  switch (process.env.NODE_ENV) {
    case "test":
      return "https://test.b-chem.com";
    case "production":
      return "https://bxxt.b-chem.com";
    default:
      return "https://test.b-chem.com";
  }
};
const baseCaptcha = () => {
  // console.log(process.env,5666666666666);
  switch (process.env.NODE_ENV) {
    case "production":
      return "https://www.b-chem.com";
    default:
      return "https://test-p001-portal.bchem.cn";
  }
};

const baseGateway = () => {
  switch (process.env.NODE_ENV) {
    case "test":
      return "https://test.b-chem.com";
    case "production":
      return "https://bwty.b-chem.com";
    default:
      return "/api";
  }
};

const base3Xway = () => {
  switch (process.env.NODE_ENV) {
    case "test":
      return "https://bridge-v2.b-chem.com";
    case "production":
      return "https://bridge-v2.b-chem.com";
    default:
      return "/3x-api";
  }
};

const cookieBase = () => {
  // switch (process.env.NODE_ENV) {
  // case "production":
  return process.env.VUE_APP_SERVE;
  // default:
  // return "https://test.b-chem.com";
  // }
};

const cookieBaseNew = () => {
  switch (process.env.NODE_ENV) {
    case "production":
      return "https://hgb-prod-obs.obs.cn-east-3.myhuaweicloud.com";
    default:
      // return process.env.VUE_APP_SERVE;
      return "https://hgb-prod-obs.obs.cn-east-3.myhuaweicloud.com";
  }
};

const base3xHarf = () => {
  switch (process.env.NODE_ENV) {
    case "production":
      return "https://www.b-chem.com";
    default:
      return "https://test-p001-portal.bchem.cn";
  }
  // return 'https://prod-p001-portal.b-chem.cn/register-enterprise?step=1'
};

const domains = {
  chem: "b-chem.com",
};

export {
  beixiu,
  base,
  cookieBase,
  baseGateway,
  base3Xway,
  domains,
  base3xHarf,
  baseCaptcha,
  cookieBaseNew,
};
